//
// DisplayRecord.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "../media/particles/SubscribeMethod";

var DisplayRecord = createModule("transport::DisplayRecord", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        dateCreated: 9,
        subscribeMethod: 4,
        dateLastViewed: 9,
        isDisplayed: 2,
        displayedCount: 4,
        isGenerateInProgress: 2,
        dateUpdated: 9,
        subscribedWithUserState: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DisplayRecord;
